import React from "react";

import Chip from "@mui/material/Chip";

import {
  TaskBasicInfo,
  TaskStatus,
} from "@fartherfinance/frontend/api/Tasks/Types";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./TaskProgressChip.module.css";

interface TaskProgressChipProps {
  className?: string;
  variant: "counter-only" | "counter-and-label";
  subtasks: TaskBasicInfo[];
}

const TaskProgressChip: React.FC<TaskProgressChipProps> = ({
  className,
  variant,
  subtasks,
}) => {
  const notCanceled = subtasks.filter(
    (task) => task.taskStatus !== TaskStatus.enum.CANCELED
  ).length;
  const done = subtasks.filter(
    (task) => task.taskStatus === TaskStatus.enum.COMPLETED
  ).length;

  if (variant === "counter-only") {
    return (
      <Chip
        classes={{
          root: toClassName(styles.chip, className),
          label: styles.chipLabel,
        }}
        variant="outlined"
        label={`${done}/${notCanceled}`}
      />
    );
  }

  return (
    <Chip
      classes={{
        root: toClassName(styles.chipVariant, className),
        label: styles.chipLabelVariant,
      }}
      variant="outlined"
      label={`${done}/${notCanceled} Completed`}
    />
  );
};

export default TaskProgressChip;
